module.exports = "/gp/img/loading.026.jpg";